import { Button } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { RECORD_STATE } from "Constants";
import { useStoreState } from "easy-peasy";
import React from "react";
import { Link, useRouteMatch } from "react-router-dom";
import { GenerateBackPath } from "Utils";

export default function EditButton({ record, ...props }) {
  let match = useRouteMatch();

  const rootPath = GenerateBackPath(match.path, 4);
  const { abilities } = useStoreState((store) => store.auth);

  const IsEnabled =
    record?.state === RECORD_STATE.ACTIVE &&
    AuthCheck(abilities, AUTH_ACTIONS.WRITE, "Kiralanabilir Alanlar");

  return (
    <Button key="1" type="primary" disabled={!IsEnabled}>
      <Link to={record ? `${rootPath}/${record?.id}/duzenle` : ""}>
        Düzenle
      </Link>
    </Button>
  );
}
